var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 15.98 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 7.493a1.332 1.332 0 00-.28-.44L8.939.392a1.338 1.338 0 00-1.892 1.892l4.4 4.383H1.332a1.332 1.332 0 000 2.664h10.112l-4.4 4.383a1.338 1.338 0 101.895 1.89L15.6 8.945a1.377 1.377 0 00.28-1.452z",
    fill: "#fff"
  })));
}

export default SvgArrowRightWhite;